import styled from 'styled-components';

const StyledShopBreadCrumb = styled.button`
  color: ${({ themeProps }) => themeProps?.color || '#606060'};
  font-size: ${({ themeProps }) => themeProps?.fontSize || '14px'};
  ${({ themeProps }) => (themeProps?.fontFamily ? `font-family: ${themeProps.fontFamily};` : '')}
  outline: none;
  display: flex;
  align-items: center;
  padding: 4px 0;
  margin-right: 1.5rem;
  margin-bottom: 0.5rem;

  &:hover,
  &:focus {
    box-shadow: inset 0px -1px 0px 0px ${({ themeProps }) => themeProps?.color || '#606060'};
  }

  :disabled {
    opacity: 0.5;
    cursor: default;
    box-shadow: none;
  }

  svg {
    width: ${({ themeProps }) => themeProps?.iconSize || '10px'};
    height: ${({ themeProps }) => themeProps?.iconSize || '10px'};
    fill: ${({ themeProps }) => themeProps?.iconFill || themeProps?.color || '#606060'};
    margin-right: 6px;
  }
`;
export default StyledShopBreadCrumb;
